export default __webpack_public_path__ + "static/media/s4.fd3e1eca.JPG";